import React from "react";
import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";
import ListItemTab from "./ListItemTab";

const InterviewConfigItem = ({onClick, active}) => {
  return (
    <ListItemTab
      icon={ChatBubbleLeftEllipsisIcon}
      label="Interview Config"
      onClick={onClick}
      active={active}
    />
  );
};

export default InterviewConfigItem;
